import { render, staticRenderFns } from "./department-scheduling.vue?vue&type=template&id=ca60e784&scoped=true&"
import script from "./department-scheduling.vue?vue&type=script&lang=js&"
export * from "./department-scheduling.vue?vue&type=script&lang=js&"
import style0 from "./department-scheduling.vue?vue&type=style&index=0&id=ca60e784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca60e784",
  null
  
)

export default component.exports